"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _has2 = _interopRequireDefault(require("lodash/has"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _pick2 = _interopRequireDefault(require("lodash/pick"));

var _filter2 = _interopRequireDefault(require("lodash/filter"));

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _Col = _interopRequireDefault(require("react-bootstrap/lib/Col"));

var _FormControl = _interopRequireDefault(require("react-bootstrap/lib/FormControl"));

var _InputGroup = _interopRequireDefault(require("react-bootstrap/lib/InputGroup"));

var _FormGroup = _interopRequireDefault(require("react-bootstrap/lib/FormGroup"));

var _ControlLabel = _interopRequireDefault(require("react-bootstrap/lib/ControlLabel"));

var _HelpBlock = _interopRequireDefault(require("react-bootstrap/lib/HelpBlock"));

var _MenuItem = _interopRequireDefault(require("react-bootstrap/lib/MenuItem"));

var _DropdownButton = _interopRequireDefault(require("react-bootstrap/lib/DropdownButton"));

var _reactFinalForm = require("react-final-form");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Wrap =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Wrap, _React$Component);

  function Wrap() {
    var _this;

    _classCallCheck(this, Wrap);

    _this = _possibleConstructorReturn(this, (Wrap.__proto__ || Object.getPrototypeOf(Wrap)).call(this));
    _this.input = {};
    _this.custom = {};
    _this.dropdownButton = _this.dropdownButton.bind(_assertThisInitialized(_this));
    _this.dropDown = _this.dropDown.bind(_assertThisInitialized(_this));
    _this.renderField = _this.renderField.bind(_assertThisInitialized(_this));
    _this.options = _this.options.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Wrap, [{
    key: "options",
    value: function options(props) {
      if (props.type === 'select') {
        return this.props.children;
      }
    }
  }, {
    key: "dropDown",
    value: function dropDown(props) {
      var _this2 = this;

      var menuItem = [];
      var dropDownTitle = (0, _get2.default)(props.field, 'title', null);
      (0, _map2.default)(props.field.children, function (item, key) {
        var select = function select() {
          _this2.input.onBlur();

          _this2.input.onChange(item.props.value);
        };

        if (item.props.selected && !props.input.value) {
          dropDownTitle = item.props.children;
          menuItem.push(_react.default.createElement(_MenuItem.default, {
            key: key,
            onSelect: select
          }, item.props.children));
        } else {
          if (String(_this2.input.value) === String(item.props.value)) {
            dropDownTitle = item.props.children;
          }

          menuItem.push(_react.default.createElement(_MenuItem.default, {
            key: key,
            onSelect: select
          }, item.props.children));
        }

        if (item.props.selected) {
          menuItem.push(_react.default.createElement(_MenuItem.default, {
            key: key + '_div',
            divider: true
          }));
        }
      });
      return {
        dropDownTitle: dropDownTitle,
        menuItem: menuItem
      };
    }
  }, {
    key: "dropdownButton",
    value: function dropdownButton(props, isStatic) {
      var _dropDown = this.dropDown(props),
          dropDownTitle = _dropDown.dropDownTitle,
          menuItem = _dropDown.menuItem;

      var size = (0, _get2.default)(props.field, 'bsSize', this.props.size);

      var thisSize = function thisSize() {
        if (size !== 'medium') {
          return {
            bsSize: size
          };
        }
      };

      var disabled = false;

      if (props.field && props.field.disabled && (0, _isFunction2.default)(props.field.disabled)) {
        disabled = this.context.checkCondition(props.field.disabled());
      }

      if (isStatic === true || disabled === true) {
        return _react.default.createElement(_FormControl.default.Static, null, dropDownTitle || (0, _get2.default)(props.field, 'placeholder'));
      }

      return _react.default.createElement(_DropdownButton.default, _extends({
        key: this.input.name,
        onClick: function onClick(event) {
          event.preventDefault();
        }
      }, thisSize(), {
        title: dropDownTitle || (0, _get2.default)(props.field, 'placeholder'),
        id: 'input-dropdown-addon' + this.input.name
      }), menuItem);
    }
  }, {
    key: "renderField",
    value: function renderField(props) {
      var _this3 = this;

      var input = props.input,
          help = props.help,
          _props$meta = props.meta,
          touched = _props$meta.touched,
          error = _props$meta.error,
          submitError = _props$meta.submitError,
          submitFailed = _props$meta.submitFailed,
          valid = _props$meta.valid,
          custom = _objectWithoutProperties(props, ["input", "help", "meta"]);

      this.input = input;
      var size = (0, _get2.default)(props.field, 'bsSize', this.props.size);

      if (props.field && props.field.hidden && (0, _isFunction2.default)(props.field.hidden)) {
        if (this.context.checkCondition(props.field.hidden, (0, _get2.default)(props, 'parent')) === true) {
          return null;
        }
      } else if (props.field && props.field.show && (0, _isFunction2.default)(props.field.show)) {
        if (this.context.checkCondition(props.field.show, (0, _get2.default)(props, 'parent')) !== true) {
          return null;
        }
      }

      var thisSize = function thisSize() {
        if (size !== 'medium') {
          return {
            bsSize: size
          };
        }
      };

      var labelSize = function labelSize() {
        if ((0, _has2.default)(props.field, 'labelSize')) {
          return props.field.labelSize;
        }
      };

      var fieldSize = function fieldSize() {
        if ((0, _has2.default)(props.field, 'fieldSize')) {
          return props.field.fieldSize;
        }
      };

      var add = (0, _pick2.default)(custom, ['type', 'placeholder', 'rows', 'cols']);

      if (add.type === 'select') {
        add.componentClass = 'select';
      }

      if (custom.field.disabled && (0, _isFunction2.default)(custom.field.disabled)) {
        add.disabled = this.context.checkCondition(custom.field.disabled, (0, _get2.default)(props, 'parent'));
      }

      if (props.field.placeholder) {
        add.placeholder = props.field.placeholder;
      }

      if (props.field.cols) {
        add.cols = props.field.cols;
      }

      if (props.field.rows) {
        add.rows = props.field.rows;
      }

      var component = function component() {
        // Render custom component
        if (_this3.props.component) {
          var Comp = _this3.props.component;
          return _react.default.createElement(Comp, props);
        }

        if (_this3.context.isStatic === true || (0, _get2.default)(props.field, 'static', false) === true) {
          var value = function value() {
            if (props.field.type === 'select') {
              return (0, _map2.default)((0, _filter2.default)(props.field.options, {
                value: _this3.input.value
              }), function (item, key) {
                return _react.default.createElement("span", {
                  key: key
                }, item.desc);
              });
            }

            return _this3.input.value;
          };

          switch (props.type) {
            case 'dropdown':
              return _this3.dropdownButton(props, true);

            default:
              {
                return _react.default.createElement(_FormControl.default.Static, null, value());
              }
          }
        }

        switch (props.field.type) {
          case 'dropdown':
            return _this3.dropdownButton(props, false);

          case 'textarea':
            return _react.default.createElement(_FormControl.default, _extends({
              componentClass: "textarea"
            }, input, add));

          case 'select':
            return _react.default.createElement(_FormControl.default, _extends({
              componentClass: "textarea"
            }, input, add), _this3.options(props));

          default:
            return _react.default.createElement(_FormControl.default, _extends({}, input, add));
        }
      };

      var validationState = function validationState() {
        if (touched && error || submitFailed && submitError) {
          return 'error';
        }

        if (touched && valid) {
          return 'success';
        }
      };

      var buttonBefore = function buttonBefore() {
        if ((0, _has2.default)(props.field, 'buttonBefore')) {
          return _react.default.createElement(_InputGroup.default.Button, null, props.field.buttonBefore());
        }
      };

      var buttonAfter = function buttonAfter() {
        if ((0, _has2.default)(props.field, 'buttonAfter')) {
          return _react.default.createElement(_InputGroup.default.Button, null, props.field.buttonAfter());
        }
      };

      var addonBefore = function addonBefore() {
        if ((0, _has2.default)(props.field, 'addonBefore')) {
          return _react.default.createElement(_InputGroup.default.Addon, null, (0, _get2.default)(props.field, 'addonBefore'));
        }
      };

      var addonAfter = function addonAfter() {
        if ((0, _has2.default)(props.field, 'addonAfter')) {
          return _react.default.createElement(_InputGroup.default.Addon, null, (0, _get2.default)(props.field, 'addonAfter'));
        }
      };

      var getField = function getField() {
        if ((0, _has2.default)(props.field, 'addonBefore') || (0, _has2.default)(props.field, 'addonAfter') || (0, _has2.default)(props.field, 'buttonBefore') || (0, _has2.default)(props.field, 'buttonAfter')) {
          return _react.default.createElement(_InputGroup.default, null, buttonBefore(), addonBefore(), component(), addonAfter(), buttonAfter());
        }

        return component();
      };

      if (props.type === 'dropdown' && !(0, _has2.default)(props.field, 'label')) {
        return getField();
      }

      var getLabel = function getLabel() {
        if (props.field.label) {
          return _react.default.createElement(_Col.default, _extends({
            componentClass: _ControlLabel.default
          }, labelSize()), props.field.label);
        }
      };

      var rendered = _react.default.createElement(_FormGroup.default, _extends({}, thisSize(), {
        validationState: validationState()
      }), getLabel(), _react.default.createElement(_Col.default, fieldSize(), getField(), (touched && error || submitFailed && submitError) && _react.default.createElement(_FormControl.default.Feedback, null), props.field.help && (!touched || !submitError && !error) && _react.default.createElement(_HelpBlock.default, null, props.field.help), (touched && error || submitFailed && submitError) && _react.default.createElement(_HelpBlock.default, null, submitError || error)));

      if (this.context.debug) {
        return _react.default.createElement("div", {
          style: {
            position: 'relative'
          }
        }, rendered);
      }

      return rendered;
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          name = _props.name,
          rest = _objectWithoutProperties(_props, ["name"]);

      return _react.default.createElement(_reactFinalForm.Field, {
        component: this.renderField,
        type: this.props.type,
        name: name,
        field: rest
      });
    }
  }]);

  return Wrap;
}(_react.default.Component);

Wrap.propTypes = {
  'field': _propTypes.default.object,
  'size': _propTypes.default.string,
  'addField': _propTypes.default.func,
  'static': _propTypes.default.bool,
  'name': _propTypes.default.string.isRequired,
  type: _propTypes.default.string.isRequired,
  component: _propTypes.default.func,
  children: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.array, _propTypes.default.bool])
};
Wrap.contextTypes = {
  debug: _propTypes.default.bool.isRequired,
  checkCondition: _propTypes.default.func.isRequired,
  isStatic: _propTypes.default.bool.isRequired
};
Wrap.defaultProps = {};
var _default = Wrap;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-final-form-components/dist/Bs/Wrappers/Wrap.js
// module id = 904
// module chunks = 0